import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { AlertSelectionState, DashboardFilters } from '../../dashboard.state';

/** Where the alerts an Alert List shows were sent; without a list, the newest alerts in the filters. */
export const ALERTS_MAP_WIDGET: DashboardWidgetDefinition<
  unknown,
  DashboardFilters & AlertSelectionState,
  keyof DashboardFilters
> = {
  type: 'alerts-map',
  title: 'Dashboard.AlertsMap.Title',
  description: 'A map of the listed alerts: a marker for each location and a shape for each area.',
  icon: 'map',
  loadComponent: () => import('./alerts-map-widget.component').then((m) => m.AlertsMapWidgetComponent),
  frame: 'edge',
  titleControls: true,
  filtersFor: () => ['timeRange', 'priority'],
  size: { default: { w: 8, h: 6 }, min: { w: 3, h: 3 } },
};
